<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12 col-md-6 offset-md-3">
                    <div
                        class="col-12 mt-5 mb-4 d-flex justify-content-md-center align-items-center"
                    >
                        <h2 class="color--purple-2 heading-spacing--large">
                            Wachtwoord instellen
                        </h2>
                    </div>

                    <slot name="introductionText"></slot>

                    <form action="" class="row">
                        <div class="col-12 col-lg-10 mb-4">
                            <label for="password" class="col-12 label--default"
                                >Wachtwoord</label
                            >
                            <input
                                id="password"
                                v-model="password"
                                class="input--default input--rounded"
                                type="password"
                                placeholder="Wachtwoord"
                            />
                        </div>

                        <div class="col-12 col-lg-10 mb-4">
                            <label
                                for="passwordRepeat"
                                class="col-12 label--default"
                                >Wachtwoord herhalen</label
                            >
                            <input
                                id="passwordRepeat"
                                v-model="passwordRepeat"
                                class="input--default input--rounded"
                                type="password"
                                placeholder="Wachtwoord herhalen"
                            />
                        </div>

                        <div
                            v-if="!processing && !success"
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <button class="col-8 btn btn--blue-7" @click="send">
                                <span>
                                    Wachtwoord aanpassen
                                    <i class="fas fa-arrow-right ml-2"></i>
                                </span>
                            </button>
                        </div>
                        <div
                            v-else
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <span v-if="!success">Een moment geduld...</span>
                        </div>

                        <div
                            class="col-12 col-lg-10 d-flex justify-content-md-center align-items-center"
                        >
                            <p>{{ errorMessage }}</p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {},
    data() {
        return {
            password: '',
            passwordRepeat: '',
            response: '',
            errorMessage: '',
            processing: false,
            success: false
        };
    },
    mounted() {},
    methods: {
        send(e) {
            e.preventDefault();
            this.errorMessage = '';
            this.processing = true;
            axios
                .post('/clientdashboard/account/forgotpassword/set', {
                    username: this.username,
                    password: this.password,
                    passwordrepeat: this.passwordRepeat,
                    token: this.$route.query.token,
                    guid: this.$route.query.guid,
                    email: this.$route.query.email
                })
                .then(response => {
                    this.response = response;
                    if (response.data.success) {
                        this.success = true;
                        window.location.replace(
                            response.data.redirectUrl + '?resetsuccess=true'
                        );
                    } else {
                        this.errorMessage = response.data.errorMsg;
                    }
                    this.processing = false;
                    return;
                })
                .catch(e => {
                    this.errors.push(e);
                })
                .finally(() => {
                    this.processing = false;
                });
        }
    }
};
</script>
<style></style>
